export const columnsHistory = [
    {
        Header: 'Old Value',
        accessor: 'oldValue',
        sort: false,
    },
    {
        Header: 'New Value',
        accessor: 'newValue',
        sort: false,
    },
    {
        Header: 'Date',
        accessor: 'date',
        sort: false,
    },
    {
        Header: 'Updated By',
        accessor: 'updatedUserName',
        sort: false,
    },
];


export const sizePerPageList = [
    {
        text: '5',
        value: 5,
    },
    {
        text: '10',
        value: 10,
    },
    {
        text: '25',
        value: 25,
    },
    {
        text: '50',
        value: 50,
    },
];

export const AddEvaluation = [
    {
        Header: 'Particulars',
        accessor: 'particulars',
        sort: false,
    },
    {
        Header: 'Allotted Marks',
        accessor: 'allottedMarks',
        sort: false,
    },
    {
        Header: 'Marks Obtained',
        accessor: 'marksObtained',
        sort: false,
    },
    {
        Header: 'Discrepancy Reason',
        accessor: 'discrepancyReason',
        sort: true,
    },
    {
        Header: 'Actions',
        accessor: 'view',
        sort: false,
    },
];

export const supplierRating = [
    {
        Header: 'Date',
        accessor: 'createdDate',
        sort: false,
    },
    {
        Header: 'Company Name',
        accessor: 'companyName',
        sort: true,
        width: 400,
            minWidth: 300,
            maxWidth: 400,
    },
    {
        Header: 'Product',
        accessor: 'product',
        sort: true,
    },
    {
        Header: 'Year-Mon',
        accessor: 'selectedYear',
        sort: true,
    },
    {
        Header: 'Marks',
        accessor: 'totalMarks',
        sort: true,
    },
    {
        Header: 'Grade',
        accessor: 'grade',
        sort: true,
    },

    {
        Header: 'Actions',
        accessor: 'view',
        sort: false,
    },
];

export const supplierEvaluation = [
    {
        Header: 'Particulars',
        accessor: 'particulars',
        sort: true,
        width: 400,
            minWidth: 300,
            maxWidth: 400,
    },
    {
        Header: 'Marks',
        accessor: 'marks',
        sort: false,
    },
    {
        Header: 'Status',
        accessor: 'particularStatus',
        sort: false,
    },
    {
        Header: 'Date',
        accessor: 'createdDate',
        sort: false,
    },
    {
        Header: 'Actions',
        accessor: 'view',
        sort: false,
        width: 400,
            minWidth: 130,
            maxWidth: 400,
    },
];

export const supplier = [
    {
        Header: 'Sl. No',
        accessor: 'index',
        sort: false,
    },
    {
        Header: 'Name of Supplier',
        accessor: 'name',
        sort: true,
        width: 400,
            minWidth: 300,
            maxWidth: 400,
    },
    {
        Header: 'Mail ID',
        accessor: 'email',
        sort: false,
        width: 400,
            minWidth: 200,
            maxWidth: 400,
    },
    {
        Header: 'Contact Person',
        accessor: 'contactPerson',
        sort: false,
    },
    {
        Header: 'Actions',
        accessor: 'view',
        sort: false,
        width: 400,
            minWidth: 130,
            maxWidth: 400,
    },
];

export const inventory = [
    {
        Header: 'Sl. No',
        accessor: 'index',
        sort: false,
    },
    {
        Header: 'Name of Inventory',
        accessor: 'name',
        sort: true,
        width: 400,
            minWidth: 200,
            maxWidth: 400,
    },
    {
        Header: 'Description',
        accessor: 'description',
        sort: false,
        width: 400,
            minWidth: 300,
            maxWidth: 400,
    },
    {
        Header: 'Stock',
        accessor: 'stock',
        sort: false,
    },
    {
        Header: 'Unit of Measurement (UOM)',
        accessor: 'UOM',
        sort: false,
    },
    {
        Header: 'Actions',
        accessor: 'view',
        sort: false,
        width: 400,
            minWidth: 130,
            maxWidth: 400,
    },
];

export const inventoryUsageLog = [
    {
        Header: 'Sl. No',
        accessor: 'index',
        sort: false,
    },
    {
        Header: 'Inventory',
        accessor: 'inventory_name',
        sort: true,
        width: 400,
            minWidth: 200,
            maxWidth: 400,
    },
    {
        Header: 'Quantity',
        accessor: 'quantity',
        sort: false,
    },
    {
        Header: 'Assigned To',
        accessor: 'assign_to_name',
        sort: true,
    },
    {
        Header: 'Client',
        accessor: 'client_name',
        sort: true,
        width: 400,
            minWidth: 300,
            maxWidth: 400,
    },
    {
        Header: 'Assigned By',
        accessor: 'assign_by_name',
        sort: true,
    },
    {
        Header: 'Date',
        accessor: 'createdAt',
        sort: false,
        width: 400,
            minWidth: 150,
            maxWidth: 400,
    },
    {
        Header: 'Actions',
        accessor: 'view',
        sort: false,
        width: 400,
            minWidth: 130,
            maxWidth: 400,
    },
];

export const SupplierProductRating = [
    {
        Header: 'Sl. No',
        accessor: 'index',
        sort: false,
    },
    {
        Header: 'Product',
        accessor: 'product',
        sort: true,
    },
    {
        Header: 'Year',
        accessor: 'selectedYear',
        sort: false,
    },
    {
        Header: 'Total Marks',
        accessor: 'totalMarks',
        sort: false,
    },
    {
        Header: 'Grade',
        accessor: 'grade',
        sort: false,
    },
];

export const indent = [
    {
        Header: 'Sl. No',
        accessor: 'index',
        sort: false,
    },
    {
        Header: 'Item',
        accessor: 'item',
        sort: true,
        width: 400,
        minWidth: 300,
        maxWidth: 400,
    },
    {
        Header: 'Rating',
        accessor: 'rating',
        sort: true,
    },
    {
        Header: 'Units',
        accessor: 'units',
        sort: true,
    },
    {
        Header: 'Quantity Received',
        accessor: 'quantityReceived',
        sort: true,
    },
    {
    Header: 'Approval Status',
    accessor: 'approvalStatus',
    sort: true,
    width: 400,
            minWidth: 100,
            maxWidth: 400,
},
    {
        Header: 'Date',
        accessor: 'date',
        sort: true,
        width: 400,
            minWidth: 150,
            maxWidth: 400,
    },
    {
    Header: 'Status',
    accessor: 'indent_status',
    sort: true,
     width: 400,
        minWidth: 200,
        maxWidth: 400,
},
    {
        Header: 'Actions',
        accessor: 'view',
        sort: false,
        width: 400,
            minWidth: 130,
            maxWidth: 400,
    },
];


